import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function HeroSection() {
  return <section className="bg-[#FDF8F3] min-h-screen flex flex-col justify-center py-12 px-4 md:px-6" data-id="element-35">
      <div className="max-w-6xl mx-auto w-full grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-36">
        {/* Copy Column */}
        <div className="order-2 md:order-1" data-id="element-37">
          <FadeIn data-id="element-38">
            <span className="inline-block px-3 py-1 bg-[#E8872B]/10 text-[#E8872B] font-bold text-sm rounded-full mb-6 tracking-wide uppercase" data-id="element-39">
              Para dueños de perros y gatos en apartamento
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#2D2A26] leading-tight mb-6" data-id="element-40">
              Tu apartamento no huele a mascota:{' '}
              <span className="text-[#E8872B]" data-id="element-41">
                huele a una zona que estás ignorando.
              </span>
            </h1>

            <div className="space-y-6 text-lg md:text-xl text-[#2D2A26]/80 leading-relaxed font-medium" data-id="element-42">
              <p data-id="element-43">
                Hay un tipo de vergüenza que casi nadie dice en voz alta:{' '}
                <strong className="text-[#2D2A26]" data-id="element-44">
                  cuando alguien entra a tu apartamento… y tú te preguntas si lo
                  notó.
                </strong>
              </p>

              <p data-id="element-45">
                Tú sí limpias. Tú sí recoges. Tú sí trapeas. Pero el olor
                vuelve. Y vuelve peor cuando cierras ventanas, cuando llueve,
                cuando prendes el ventilador… o cuando alguien se sienta en el
                sofá.
              </p>

              <p className="border-l-4 border-[#4A9BD9] pl-4 italic text-[#4A9BD9] font-semibold" data-id="element-46">
                La razón no es "falta de limpieza". La razón es que estás
                peleando contra el olor en el lugar equivocado.
              </p>
            </div>

            <div className="mt-8" data-id="element-47">
              <a href="https://krove.lat/cart/40640003670145:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-flex items-center justify-center px-8 py-4 bg-[#E8872B] text-white font-bold text-lg rounded-lg shadow-lg hover:bg-[#d6761f] transition-colors transform hover:-translate-y-0.5" data-id="element-48">
                Ver el Protocolo 7 Días
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-49" />
              </a>
              <p className="mt-3 text-sm text-[#2D2A26]/60" data-id="element-50">
                *Diagnóstico en 10 minutos incluido
              </p>
            </div>
          </FadeIn>
        </div>

        {/* Image Column */}
        <div className="order-1 md:order-2 flex justify-center" data-id="element-51">
          <FadeIn delay={0.2} data-id="element-52">
            <div className="relative" data-id="element-53">
              <div className="absolute inset-0 bg-[#4A9BD9]/10 rounded-2xl transform rotate-3 scale-105 z-0" data-id="element-54"></div>
              <img src="https://cdn.magicpatterns.com/uploads/if9F5E5EWekxZCn4fRjKqw/heylloyd-image-1771191822676.png" alt="Casa Sin Olor Protocolo en Tablet" className="relative z-10 rounded-xl shadow-2xl w-full max-w-md mx-auto border-4 border-white" data-id="element-55" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}